export const ROLES: { [key: string]: string } = {
  ADMIN: 'Administrador',
  MANAGER: 'Gerente',
  SELLER: 'Vendedor'
}
